import React from 'react';
import { AtSignIcon, GlobeIcon, MailIcon } from 'lucide-react';
import { CLOSING_LINE, footerLinks } from '../data/unstuckContent';
export function Footer() {
  return <footer className="w-full border-t border-charcoal-600 bg-charcoal-900 py-14" data-id="element-81" data-mp="3gh3ng3oilm9v">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-82" data-mp="32lrlpcbxyvjg">
        <p className="font-display text-2xl font-semibold uppercase tracking-[0.14em] text-ivory-50" data-id="element-83" data-mp="36qheutf7tw0o">
          Unstuck™
        </p>
        <p className="mx-auto mt-4 max-w-md text-[14px] leading-relaxed text-body" data-id="element-84" data-mp="3uftpzyu3se5m">
          The N°1 execution system for ambitious people stuck in procrastination.
        </p>
        <p className="mx-auto mt-2 max-w-md font-display text-lg italic text-champagne" data-id="element-85" data-mp="3ldkgncakmqtt">
          Because working should not cost you your weekends.
        </p>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[12px] text-body" data-id="element-86" data-mp="29ynnprb9nhh6">
          <li className="flex items-center gap-1.5" data-id="element-87" data-mp="2eyjqjn8892v5">
            <MailIcon className="h-3.5 w-3.5 text-champagne" strokeWidth={1.75} aria-hidden="true" data-id="element-88" data-mp="2evx8gtnpn4yo" />
            <a href={`mailto:${footerLinks.email}`} className="transition-colors duration-150 ease-out hover:text-champagne" data-id="element-89" data-mp="3lbdd6ucasbmc">
              {footerLinks.email}
            </a>
          </li>
          <li className="flex items-center gap-1.5" data-id="element-90" data-mp="3q83rbc4jkx54">
            <AtSignIcon className="h-3.5 w-3.5 text-champagne" strokeWidth={1.75} aria-hidden="true" data-id="element-91" data-mp="3q7byua68rfj2" />
            {footerLinks.social}
          </li>
          <li className="flex items-center gap-1.5" data-id="element-92" data-mp="34pa1a0t5yjb">
            <GlobeIcon className="h-3.5 w-3.5 text-champagne" strokeWidth={1.75} aria-hidden="true" data-id="element-93" data-mp="31uoff6267ob" />
            {footerLinks.website}
          </li>
        </ul>

        <div className="mt-10 border-t border-charcoal-600 pt-8" data-id="element-94" data-mp="cus3tcfr7gip">
          <p className="text-[13px] leading-relaxed text-muted" data-id="element-95" data-mp="qt8gdk0as18r">
            © Redondoland™ 2024 — All rights reserved. Reproduction and redistribution
            prohibited without express authorization.
          </p>
          <p className="mt-5 text-[11px] font-semibold uppercase tracking-[0.2em] text-champagne" data-id="element-96" data-mp="tvw9ald1dni3">
            “{CLOSING_LINE}”
          </p>
        </div>
      </div>
    </footer>;
}